// Get Predefined Goals List
export const GET_PREDEFINED_GOALS_LIST_SUCCESS = "GET_PREDEFINED_GOALS_LIST_SUCCESS";
export const GET_PREDEFINED_GOALS_LIST_FAILURE = "GET_PREDEFINED_GOALS_LIST_FAILURE";

// Get Predefined Goal by ID
export const GET_PREDEFINED_GOAL_BY_ID_SUCCESS = "GET_PREDEFINED_GOAL_BY_ID_SUCCESS";
export const GET_PREDEFINED_GOAL_BY_ID_FAILURE = "GET_PREDEFINED_GOAL_BY_ID_FAILURE";

// Clear Predefined Goals State
export const CLEAR_PREDEFINED_GOALS_STATE = "CLEAR_PREDEFINED_GOALS_STATE";